import axios from 'settings/axios'
import { apiEndpoints } from 'settings/_apiSettings'

import { NotificationTypeEnum } from './notificationPreferences'
import { TranscribeAudioType } from './transcription/service'

export interface MePreferencesData {
  schedule_notification_type: NotificationTypeEnum | null
  transcribe_audio: TranscribeAudioType
}

interface MePreferencesResponse {
  preferences: MePreferencesData
}

export const fetchPreferences = async (): Promise<MePreferencesData> => {
  const { data } = await axios.get<MePreferencesResponse>(apiEndpoints.ME_PREFERENCES)
  return data?.preferences
}
